import React, { Fragment } from "react";

/*COMPONENTS*/
import Header from "./components/Header";
import Appointment from "./components/Appointments";

function App() {
  return (
    <Fragment>
      <Header />
      <Appointment />
    </Fragment>
  );
}

export default App;
